import Footer from "common/footer";
import MenuHeader from "features/menu/blocks/MenuHeader";
import type { Page } from "features/pages/types";
import { usePageContentCheck } from "features/pages/usePageContentCheck";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ContentUnavailable from "ui/ContentUnavailable";
import LoadingPlaceholder from "ui/LoadingPlaceholder";

import "./CatchAllPage.css";

type CatchAllPageProps = {
  pagesByPath: Record<string, Page>;
};

const CatchAllPage: React.FC<CatchAllPageProps> = ({ pagesByPath }) => {
  const { pathname, hash } = useLocation();

  const page = pagesByPath[pathname];
  const isExternalRedirect = page?.kind === "external" && !!page.contentUrl;
  const contentCheck = usePageContentCheck(
    page?.contentUrl && !isExternalRedirect ? page.id : undefined,
  );

  useEffect(() => {
    if (isExternalRedirect) {
      window.location.replace(page.contentUrl as string);
    }
  }, [isExternalRedirect, page?.contentUrl]);

  if (isExternalRedirect) return null;

  const renderContent = () => {
    if (!page?.contentUrl) return <div>404 No such page</div>;
    if (!contentCheck) return <LoadingPlaceholder />;
    if (!contentCheck.ok) return <ContentUnavailable />;

    return (
      <iframe
        key={pathname}
        className="catch-all-page__iframe"
        src={`${page.contentUrl}${hash || ""}`}
        title={page.title}
      />
    );
  };

  return (
    <div className="catch-all-page">
      <MenuHeader menuSlug={page?.menuSlug ?? undefined} />
      {renderContent()}
      {page?.showFooter && <Footer />}
    </div>
  );
};

export default CatchAllPage;
